import { Typography as MuiTypography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  title: {
    margin: '20px 0px',
    textAlign: 'center'
  }
});

export default function Typography({ text, variant = 'h1', className }) {
  const classes = useStyles();

  return (
    <MuiTypography variant={variant} className={className ? className : classes.title}>
      {text}
    </MuiTypography>
  );
}
